/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class LicenseBenefitSavingRequest {
    getFixupPrototypeFunction() { return LicenseBenefitSavingRequest.fixupPrototype; }

    static newInstance(model: Partial<LicenseBenefitSavingRequest>): LicenseBenefitSavingRequest {
        let obj = Object.assign(new LicenseBenefitSavingRequest(), model);
        LicenseBenefitSavingRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<LicenseBenefitSavingRequest>): LicenseBenefitSavingRequest {
        if (!model) return null;
        return LicenseBenefitSavingRequest.newInstance(<LicenseBenefitSavingRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: LicenseBenefitSavingRequest) {
        if (!obj) return;

        models.LicenseBenefitSavingRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: LicenseBenefitSavingRequest): boolean {
        Object.setPrototypeOf(obj, LicenseBenefitSavingRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * currency of the cost. Example 'currency':'USD'
     */
    currency: models.Currency;

    service_names: Array<models.CloudServiceName>;

    /**
     * Specify the tenant ID. This is a unique ID  and can be retrieved using the List Tenants API.
     */
    tenant_id: Array<string>;

}
